/* eslint-disable */
import React from 'react';
import DOMPurify from 'dompurify';

export const getRandomInt = (min, max) => {
  const minM = Math.ceil(min);
  const maxM = Math.floor(max);
  return Math.floor(Math.random() * (maxM - minM + 1)) + minM;
};

export const stringTruncateFormat = (string, length = 100, suffix = '...') => {
  if (string && string.length > length) {
    return `${string.substring(0, length)}${suffix}`;
  }
  return string;
};

export function printHtml(html) {
  return (
    // eslint-disable-next-line react/no-danger
    <span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(html, { ADD_ATTR: ['target'] }) }} />
  );
}

export function htmlTagsExist(string) {
  return /<\/?[a-z][\s\S]*>/i.test(string);
}

/**
 * Генерация элемента по строковому шаблону.Например "Списание за изменение заказа {link}"
 * Можен принимать компоненты для замены, например Link и тп
 * @param {string} templateString Текстовый шаблон
 * @param {object} data Данные для шаблона
 */
export function template(templateString, data) {
  if (!data) {
    return templateString;
  }
  const regExp = new RegExp(/(?={)(.*?)(?<=})/, 'g');
  let parts = templateString.split(regExp).filter(item => item !== '');
  parts = parts.map(part => {
    let partResult = part;
    // Если начинается с { значит это шаблон, делаем рендер по нему
    if (part[0] === '{') {
      const templateName = part.match(/(?<={)(.*?)(?=\[|})/g)[0];
      // console.log(templateName);
      if (typeof data[templateName] !== 'undefined') {
       //  console.log(data[templateName]);
        if (typeof data[templateName] === 'function') {
          const templateArgs = part
            .match(/(?<=\[)(.*?)(?=\])/g)
            .reduce((result, item) => {
              const v = item.split(':');
              // eslint-disable-next-line no-param-reassign
              result[v[0]] = v[1];
              return result;
            }, {});

          // console.log(templateArgs);
          return data[templateName](templateArgs);
        }
        partResult = data[templateName];
      }
    }
    // Если в данных для шаблона точно нет нужного значения то значит это просто текст, возвращаем эту подстроку
    // (например если public_comment: null)
    if (htmlTagsExist(partResult)) {
      return <span dangerouslySetInnerHTML={{ __html: partResult }} />;
    }
    return partResult;
  });
  if (
    Array.isArray(parts) &&
    parts.every(item => typeof item === 'string' || typeof item === 'number')
  ) {
    return parts.join('');
  }

  return <span>{parts}</span>;
}

export default null;



// WEBPACK FOOTER //
// ./src/utils/index.js